import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconEyeOutline = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconEyeOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M12.003 16.873a4.843 4.843 0 0 0 4.874-4.876 4.847 4.847 0 0 0-4.874-4.873 4.845 4.845 0 0 0-4.874 4.875 4.85 4.85 0 0 0 4.874 4.873m0-1.849a2.9 2.9 0 0 1-2.143-.9 2.93 2.93 0 0 1-.883-2.129 2.9 2.9 0 0 1 .9-2.142 2.93 2.93 0 0 1 2.128-.884 2.9 2.9 0 0 1 2.143.9 2.93 2.93 0 0 1 .883 2.129 2.9 2.9 0 0 1-.9 2.143 2.93 2.93 0 0 1-2.128.883m0 5.412a12.47 12.47 0 0 1-6.899-2.01 13.86 13.86 0 0 1-4.86-5.356 1.4 1.4 0 0 1-.187-.5 3.1 3.1 0 0 1 0-1.152c.034-.183.097-.36.187-.522a13.9 13.9 0 0 1 4.86-5.326 12.48 12.48 0 0 1 6.899-2.01A12.48 12.48 0 0 1 18.9 5.57a13.9 13.9 0 0 1 4.861 5.33c.09.162.153.339.187.521.072.381.072.772 0 1.152a1.4 1.4 0 0 1-.187.5 13.86 13.86 0 0 1-4.86 5.354 12.47 12.47 0 0 1-6.9 2.009m0-1.956a10.9 10.9 0 0 0 6.026-1.753 11.46 11.46 0 0 0 4.178-4.728 11.46 11.46 0 0 0-4.178-4.728 10.9 10.9 0 0 0-6.026-1.755c-2.14-.016-4.24.594-6.039 1.755a11.43 11.43 0 0 0-4.19 4.728 11.43 11.43 0 0 0 4.19 4.727 11 11 0 0 0 6.039 1.755" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconEyeOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
